import React from "react";
import android from "../assets/images/android.svg"
import react from "../assets/images/react2.svg"
import java from "../assets/images/java.svg"
import git from "../assets/images/git.svg"
import jquery from "../assets/images/jquery.svg"
import node from "../assets/images/node.svg"
import js from "../assets/images/js.svg"
import html from "../assets/images/html2.svg"
import css from "../assets/images/css2.svg"
import aws from "../assets/images/aws.svg"

const More = () => {

  const data = [
    {
      alt:"React",
      src:react,
      href:"https://reactjs.org/"
    },
    {
      alt:"Android",
      src:android,
      href:"https://www.android.com/"
    },
    {
      alt:"JavaScript",
      src:js,
      href:"https://developer.mozilla.org/en-US/docs/Web/JavaScript"
    },
    {
      alt:"HTML",
      src:html,
      href:"https://developer.mozilla.org/en-US/docs/Web/HTML"
    },
    {
      alt:"CSS",
      src:css,
      href:"https://developer.mozilla.org/en-US/docs/Web/CSS"
    },
    {
      alt:"Java",
      src:java,
      href:"https://www.java.com"
    },
    {
      alt:"AWS",
      src:aws,
      href:"https://aws.amazon.com/"
    },
    {
      alt:"Git",
      src:git,
      href:"https://git-scm.com"
    },
    {
      alt:"NodeJS",
      src:node,
      href:"https://nodejs.org"
    },
    {
      alt:"jQuery",
      src:jquery,
      href:"https://jquery.org/history"
    }
  ]

  return (
    <div className="rn-testimonial-area bg_color--5 ptb--120">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="react-tabs" data-rttabs="true">
              <div
                className="react-tabs__tab-panel react-tabs__tab-panel--selected"
                role="tabpanel"
                id="react-tabs-1"
                aria-labelledby="react-tabs-0"
              >
                <div className="rn-testimonial-content text-center">
                  <div className="inner">
                    <p>
                      Skills
                    </p>
                  </div>
                  <div id="Skills0" className="author-info">
                    <h6>
                      <span>Note </span> - All SVG animations are self designed using keyframes.
                    </h6>
                  </div>
                </div>
              </div>
              <ul className="brand-style-2" /*testimonial-thumb-wrapper*/ role="tablist">
                {data.map((item,i)=>{
                return (<li
                    className="react-tabs__tab show-on-scroll"
                    role="tab"
                    id="react-tabs-0"
                    aria-selected="true"
                    aria-disabled="false"
                    aria-controls="react-tabs-1"
                    tabIndex="0"
                    data-rttab="true"
                    key={item+i}
                  >
                    <div className="testimonial-thumbnai">
                      <div className="thumb">
                        <a href={item.href} target="_blank" rel='noopener noreferrer'>
                          <img
                            className="testimonial"
                            src={item.src}
                            alt={item.alt}
                          />
                        </a>
                      </div>
                    </div>
                  </li>)}
                )}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default More;
